import { ITour } from '../../types/project';
import { IApplicationState } from '../../types/redux';

export const selectTour = (state: IApplicationState): ITour | undefined => {
  return state.projectData.project.tour;
};
